var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8407 8.95536C25.8969 15.142 22.4413 21.8066 16.1584 23.8032C9.87557 25.8279 3.1072 22.4253 1.07954 16.2387C-0.948112 10.0521 2.47891 3.38742 8.76179 1.39083C9.96125 0.997141 11.2178 0.800293 12.4744 0.800293C17.6435 0.828414 22.2129 4.11856 23.8407 8.95536ZM12.4458 1.86889C6.41999 1.86889 1.56503 6.67757 1.56503 12.6111C1.56503 18.5446 6.44855 23.3252 12.4744 23.3252C18.5002 23.3252 23.3552 18.5165 23.3552 12.583C23.3552 11.4581 23.1839 10.3614 22.8126 9.29282C21.3561 4.87783 17.1866 1.86889 12.4458 1.86889Z",
    fill: "#1186C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96236 10.5591H10.247V17.8159H7.96236V10.5591ZM9.10471 6.95877C9.84723 6.95877 10.4184 7.54944 10.4184 8.28075C10.4184 9.01206 9.81867 9.57461 9.07615 9.57461C8.33362 9.57461 7.76245 8.98394 7.76245 8.28075C7.76245 7.52132 8.36218 6.95877 9.10471 6.95877Z",
    fill: "#1186C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6462 10.5583H13.8452V11.5428C14.3022 10.7833 15.1304 10.3333 16.0157 10.3614C18.3289 10.3614 18.7573 11.8522 18.7573 13.8211V17.787H16.5298V14.2711C16.5298 13.4273 16.5297 12.3585 15.3303 12.3585C14.1308 12.3585 13.9595 13.2867 13.9595 14.1867V17.787H11.6462V10.5583Z",
    fill: "#1186C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkd);
export default __webpack_public_path__ + "static/media/linkd.0c67e8842bc105b1f07c12124df95b3d.svg";
export { ForwardRef as ReactComponent };